var map = {
	"./Configurations and Personalized Support.webp": 640,
	"./Contact banner.webp": 9939,
	"./Corporate banner.webp": 4814,
	"./Fiber's Edge Over Copper banner.webp": 223,
	"./Hosp Banner.webp": 2531,
	"./Optimized Fiber-Optic Solution baanner .webp": 5540,
	"./Resident banner.webp": 4777,
	"./Scalable andFuture-Ready Design banner.webp": 4222,
	"./Student banner.webp": 7170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3679;